import { LOCALE_CODES, DEFAULT_LOCALE } from '~/constants/i18n';

const LEGACY_SEGMENT = '24sold';
const NEW_SEGMENT = 'resale';

const isPrefixLocale = (s: string | undefined): boolean =>
  !!s && s !== DEFAULT_LOCALE && (LOCALE_CODES as readonly string[]).includes(s);

// ID-128: /24sold (and /<locale>/24sold) moved to /resale. Returns the target with the
// query and hash kept, or null when the path is not the legacy page.
export const legacyResaleRedirect = (pathWithQuery: string): string | null => {
  const cut = pathWithQuery.search(/[?#]/);
  const path = cut === -1 ? pathWithQuery : pathWithQuery.slice(0, cut);
  const rest = cut === -1 ? '' : pathWithQuery.slice(cut);
  const segments = path.split('/').filter(Boolean);
  if (segments.length === 1 && segments[0].toLowerCase() === LEGACY_SEGMENT) return `/${NEW_SEGMENT}${rest}`;
  if (segments.length === 2 && isPrefixLocale(segments[0]) && segments[1].toLowerCase() === LEGACY_SEGMENT) {
    return `/${segments[0]}/${NEW_SEGMENT}${rest}`;
  }
  return null;
};
